import React, { memo, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Link, useLocation } from 'react-router-dom';
import { Breadcrumb } from 'antd';
import { poorConnectionBanner } from '../alert/popAlert';

import actions from '@flux/action';
// import '@style/components/breadcrumb.scss';
import '../../styles/components/breadcrumb.scss';

function itemRender(route, params, routes, paths) {
  const last = routes.indexOf(route) === routes.length - 1;
  return last ? (
    <span className="breadcrumb-text last">{route.breadcrumbName}</span>
  ) : (
    <Link className="breadcrumb-text" to={route.path}>
      {route.breadcrumbName}
    </Link>
  );
}

function BreadCrumb(props) {
  const location = useLocation();
  const dispatch = useDispatch();
  const { data, customizedModules } = useSelector(({ common, projects }) => ({
    data: common.breadcrumb,
    customizedModules: projects?.customizedModules,
  }));
  useEffect(() => {
    poorConnectionBanner.onPageChange();
    dispatch(actions.matchBreadCrumb());
  }, [location.pathname, location.search, customizedModules]);

  return (
    <>
      <a className="landing-page-breadcrumb" href="/">
        <span
          style={{ fontWeight: 'bold', color: 'var(--fontColorHighContrast)' }}
        >
          M&A Gateway
        </span>
        <span className="after-landing-page-separator">/</span>
      </a>
      <Breadcrumb
        className="breadcrumb-wrapper"
        itemRender={itemRender}
        routes={data}
        key={JSON.stringify(data)} // temporary fix for key conflict of breadcrumb item
      />
    </>
  );
}

export default memo(BreadCrumb);
